// extracted by mini-css-extract-plugin
export default {"root":"ProvidedContainerLayout-root_cra0e","containerInfo":"ProvidedContainerLayout-containerInfo_OTddV","containerPrices":"ProvidedContainerLayout-containerPrices_SdiSu"};